<div class="reportsPage prodAvailability">
  <h3>Shippable Products </h3>
  <div class="form-sec productFilterDropDown">
    <div class="row margin-t20 margin-b10">
      <div class="col-md-9 col-lg-10 smallPadRgt0">
        <div class="row search-box-outer">
          <div class="col-md-4 col-lg-3 padding-r0 borderRight padding-r0">
            <div class="category-dropdown material-select">
              <ng-select [items]="searchTypeList"
                         name="ddlProductSearch"
                         [(ngModel)]="selectedValue"
                         (ngModelChange)="enableDisableSearch()"
                         [virtualScroll]="true"
                         [closeOnSelect]="true"
                         [selectOnTab]="true"
                         [clearable]="false"
                         bindValue="value"
                         labelForId="name"
                         [searchable]="false"
                         (change)="keepFilter(null,' ')">
              </ng-select>
            </div>
          </div>
          <div class="col-md-8 col-lg-9 padding-l0 padding-r0">
            <div class="material-select reports-search-filter">
              <ng-select #ProductLine name="ddlproductSearch" *ngIf="selectedValue === 'Product Line'"
                         [items]="productLineMasterList"
                         placeholder="Search..."
                         class="custom-select-grower"
                         [multiple]="true"
                         [hideSelected]="true"
                         [(ngModel)]="productFilters.ProductLineList"
                         [virtualScroll]="true"
                         bindLabel="value"
                         bindValue="value"
                         [closeOnSelect]="true"
                         [searchFn]="filterSearchFn"
                         (change)="keepFilter(ProductLine,'ProductLine')">
                <ng-template ng-option-tmp let-item="item" let-index="index" let-search="searchTerm">
                  <div class="dropdown-template">
                    <div class="row">
                      <div class="col-md-8">
                        <p class="name">
                          {{item.value}}
                        </p>
                      </div>
                    </div>
                  </div>
                </ng-template>
                <ng-template ng-notfound-tmp let-searchTerm="searchTerm">
                  <div class="ng-option disabled">
                    No data found for "{{searchTerm}}"
                  </div>
                </ng-template>
              </ng-select>

              <ng-select #MarketingBrand name="ddlproductSearch" *ngIf="selectedValue === 'Marketing Brand'"
                         [items]="marketingMasterList"
                         placeholder="Search..."
                         class="custom-select-grower"
                         [multiple]="true"
                         [hideSelected]="true"
                         [(ngModel)]="productFilters.MarketingBrandList"
                         [virtualScroll]="true"
                         bindLabel="value"
                         bindValue="value"
                         [closeOnSelect]="true"
                         [searchFn]="filterSearchFn"
                         (change)="keepFilter(MarketingBrand,'MarketingBrand')">
                <ng-template ng-option-tmp let-item="item" let-index="index" let-search="searchTerm">
                  <div class="dropdown-template">
                    <div class="row">
                      <div class="col-md-8">
                        <p class="name">
                          {{item.value}}
                        </p>
                      </div>
                    </div>
                  </div>
                </ng-template>
                <ng-template ng-notfound-tmp let-searchTerm="searchTerm">
                  <div class="ng-option disabled">
                    No data found for "{{searchTerm}}"
                  </div>
                </ng-template>
              </ng-select>

              <div #productSearch *ngIf="selectedValue === 'Product Name'">
                <div class="search-box-outer margin-l10">
                  <div class="search-box wide100">
                    <span class="search-icon">
                      <i class="fas fa-search"></i>
                    </span>
                    <div class="select-container">
                      <!--<input (keyup.enter)="getShippableProductsRecords()" [(ngModel)]="productFilters.Brand" (ngModelChange)="validateBrandSearch()"
                      placeholder="Search" type="text">-->
                      <input (keyup.enter)="keepFilter(null, ' ')" [(ngModel)]="productFilters.Brand" (ngModelChange)="validateBrandSearch()"
                             placeholder="Search..." type="text">
                    </div>
                  </div>
                </div>
              </div>

              <ng-select #Technology name="ddlproductSearch" *ngIf="selectedValue === 'Technology'"
                         [items]="technologyMasterList"
                         placeholder="Search..."
                         class="custom-select-grower"
                         [multiple]="true"
                         [hideSelected]="true"
                         [(ngModel)]="productFilters.TechnologyList"
                         [virtualScroll]="true"
                         bindLabel="value"
                         bindValue="value"
                         [closeOnSelect]="true"
                         [searchFn]="filterSearchFn"
                         (change)="keepFilter(Technology,'Technology')">
                <ng-template ng-option-tmp let-item="item" let-index="index" let-search="searchTerm">
                  <div class="dropdown-template">
                    <div class="row">
                      <div class="col-md-8">
                        <p class="name">
                          {{item.value}}
                        </p>
                      </div>
                    </div>
                  </div>
                </ng-template>
                <ng-template ng-notfound-tmp let-searchTerm="searchTerm">
                  <div class="ng-option disabled">
                    No data found for "{{searchTerm}}"
                  </div>
                </ng-template>
              </ng-select>

              <ng-select #SeedSize name="ddlproductSearch" *ngIf="selectedValue === 'Seed Size'"
                         [items]="seedsizeMasterList"
                         placeholder="Search..."
                         [multiple]="true"
                         [hideSelected]="true"
                         class="custom-select-grower"
                         [(ngModel)]="productFilters.SeedSizeList"
                         [virtualScroll]="true"
                         bindLabel="value"
                         bindValue="value"
                         [closeOnSelect]="true"
                         [searchFn]="filterSearchFn"
                         (change)="keepFilter(SeedSize,'SeedSize')">
                <ng-template ng-option-tmp let-item="item" let-index="index" let-search="searchTerm">
                  <div class="dropdown-template">
                    <div class="row">
                      <div class="col-md-8">
                        <p class="name">
                          {{item.value}}
                        </p>
                      </div>
                    </div>
                  </div>
                </ng-template>
                <ng-template ng-notfound-tmp let-searchTerm="searchTerm">
                  <div class="ng-option disabled">
                    No data found for "{{searchTerm}}"
                  </div>
                </ng-template>
              </ng-select>

              <ng-select #AccountNo *ngIf="selectedValue === 'Account' && isEvolveAccountRestriction == true"
                         [items]="ddlAccounts"
                         placeholder="Search..."
                         class="custom-select-grower"
                         [multiple]="true"
                         [hideSelected]="true"
                         [(ngModel)]="productFilters.AccountNo"
                         [virtualScroll]="true"
                         bindLabel="accountNameCityState"
                         bindValue="accountNumber"
                         [closeOnSelect]="true"
                         [searchFn]="accountSearchFn"
                         (change)="keepFilter(null, ' ')">
                <ng-template ng-option-tmp let-item="item" let-index="index" let-search="searchTerm">
                  <div class="dropdown-template">
                    <div class="row" *ngIf="item.accountNumber!=-1">
                      <div class="col-md-8">
                        <h4 class="name greenColor" [ngOptionHighlight]="search">
                          {{item.accountName}}
                        </h4>
                        <p class="address" [ngOptionHighlight]="search">
                          {{item.address1}},  {{item.city}}, {{item.state}} - {{item.zipCode}}
                        </p>
                        <p class="phoneNo" [ngOptionHighlight]="search">
                          {{item.primaryPhoneNumber}}
                        </p>
                        <p class="grower-nos">
                          <span class="grower-gln" [ngOptionHighlight]="search">
                            Account #: {{item.accountNumber}}
                          </span>
                        </p>
                      </div>
                    </div>
                    <div class="row" *ngIf="item.accountNumber==-1">
                      <div class="col-md-8">
                        <h4 class="name" [ngOptionHighlight]="search">
                          {{item.accountName}}
                        </h4>
                        <p class="grower-nos">
                          <span class="grower-gln" [ngOptionHighlight]="search">
                            Account #: {{item.accountNumber}}
                          </span>
                        </p>
                      </div>
                    </div>
                  </div>
                </ng-template>
                <ng-template ng-notfound-tmp let-searchTerm="searchTerm">
                  <div class="ng-option disabled">
                    No data found for "{{searchTerm}}"
                  </div>
                </ng-template>
              </ng-select>
              <div #productSearch *ngIf="selectedValue === 'Account No' && isEvolveAccountRestriction == false">
                <div class="search-box-outer margin-l10">
                  <div class="search-box wide100">
                    <span class="search-icon">
                      <i class="fas fa-search"></i>
                    </span>
                    <div class="select-container">
                      <input (keyup.enter)="keepFilter(null, ' ');" [(ngModel)]="productFilters.TxtAccountNo"
                             placeholder="Search..." type="text" pattern="^[0-9, ]+$" #accountCtrl>
                    </div>
                  </div>
                </div>
              </div>

              <!--<div class="search-box-outer" *ngIf="selectedValue === 'Ship To'">
                <div class="reports-search-filter">
                  <div class="search-box-outer">
                    <div class="search-box wide100">
                      <span class="search-icon">
                        <i class="fas fa-search"></i>
                      </span>
                      <div class="select-container">
                        <input (keyup.enter)="keepFilter(null, ' ')" placeholder="Search..." type="text" [(ngModel)]="productFilters.TxtAccountNo">
                      </div>
                    </div>
                  </div>
                </div>
              </div>-->

              <ng-select #itemNo name="ddlproductSearch" *ngIf="selectedValue === 'Item Number'"
                         [items]="itemNoList"
                         placeholder="Search..."
                         class="custom-select-grower"
                         [multiple]="true"
                         [hideSelected]="true"
                         [(ngModel)]="productFilters.ItemNo"
                         [virtualScroll]="true"
                         bindLabel="value"
                         bindValue="value"
                         [closeOnSelect]="true"
                         [searchFn]="filterSearchFn"
                         (change)="keepFilter(itemNo,'ItemNo')">
                <ng-template ng-option-tmp let-item="item" let-index="index" let-search="searchTerm">
                  <div class="dropdown-template">
                    <div class="row">
                      <div class="col-md-8">
                        <p class="name">
                          {{item.value}}
                        </p>
                      </div>
                    </div>
                  </div>
                </ng-template>
                <ng-template ng-notfound-tmp let-searchTerm="searchTerm">
                  <div class="ng-option disabled">
                    No data found for "{{searchTerm}}"
                  </div>
                </ng-template>
              </ng-select>

              <div #productSearch *ngIf="selectedValue === 'Account Name' && isEvolveAccountRestriction == false ">
                <div class="search-box-outer margin-l10">
                  <div class="search-box wide100">
                    <span class="search-icon">
                      <i class="fas fa-search"></i>
                    </span>
                    <div class="select-container">
                      <input (keyup.enter)="keepFilter(null, ' ');" [(ngModel)]="productFilters.AccountName"
                             placeholder="Search..." type="text">
                    </div>
                  </div>
                </div>
              </div>

              <!--<ng-select #ItemNo name="ddlproductSearch" *ngIf="selectedValue === 'Package Size'"
                         [items]="packagesizeMasterList"
                         placeholder="Search"
                         class="custom-select-grower"
                         [multiple]="true"
                         [hideSelected]="true"
                         [(ngModel)]="productFilters.PackageSizeList"
                         [virtualScroll]="true"
                         bindLabel="value"
                         bindValue="value"
                         [closeOnSelect]="true"
                         [searchFn]="filterSearchFn"
                         (change)="keepFilter(ItemNo,'ItemNo')">
                <ng-template ng-option-tmp let-item="item" let-index="index" let-search="searchTerm">
                  <div class="dropdown-template">
                    <div class="row">
                      <div class="col-md-8">
                        <p class="name">
                          {{item.value}}
                        </p>
                      </div>
                    </div>
                  </div>
                </ng-template>
                <ng-template ng-notfound-tmp let-searchTerm="searchTerm">
                  <div class="ng-option disabled">
                    No data found for "{{searchTerm}}"
                  </div>
                </ng-template>
              </ng-select>-->

              <div class="col-md-6 maturitySelect" *ngIf="selectedValue === 'Desired Delivery Date'">
                <div class="text-center deliveryDatePicker">
                  <mat-form-field>
                    <input matInput [matDatepicker]="picker" (focus)="picker.open();" placeholder="From" [matDatepickerFilter]="fromDateFilter"
                           readonly [(ngModel)]="productFilters.FromDate" (dateChange)="keepFilter();validateDateFilter('fromDate', $event);">
                    <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                    <mat-datepicker #picker></mat-datepicker>
                  </mat-form-field>
                </div>
              </div>

              <div class="col-md-6 maturitySelect" *ngIf="selectedValue === 'Desired Delivery Date'">
                <div class="text-center deliveryDatePicker">
                  <mat-form-field>
                    <input matInput [matDatepicker]="picker" (focus)="picker.open();" placeholder="To" [matDatepickerFilter]="toDateFilter"
                           readonly [(ngModel)]="productFilters.ToDate" (dateChange)="keepFilter();validateDateFilter('toDate', $event);">
                    <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                    <mat-datepicker #picker></mat-datepicker>
                  </mat-form-field>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-md-3 col-lg-2 search-btn-outer text-right padding-l10 ">
        <div class="search-btn margin-r10 smallMarRgt5">
          <button mat-raised-button class="btns" color="primary" (click)="getShippableProductsRecords()">Search</button>
        </div>
        <div class="export-btn">
          <button mat-raised-button class="btns" color="primary" (click)="onExportBtnClick()" [disabled]="shipableProductDataSource?.data.length <= 0">Export</button>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-9 col-lg-10 text-right margin-t5 padding-r0">
        Do not display records with Shippable Quantities of 0
        <mat-checkbox class="custom-checkbox margin-l10" [(ngModel)]="filter.includeShippableQtyZero"></mat-checkbox>
      </div>
    </div>
    <div class="row">
      <div class="col-md-10 padding-r0">
        <div class="chips-sec">
          <div class="row selected-chip">
            <div class="col-sm-9 col-md-10 padding-l0">
              <div>
                <mat-chip-set>
                  <mat-chip selected *ngFor="let filterValue of filterValueList">
                    {{filterValue}}
                    <a href="Javascript:void(0);" (click)="clearFilter(filterValue)">
                      <i class="fas fa-times text-right"></i>
                    </a>
                  </mat-chip>
                </mat-chip-set>
              </div>
            </div>
            <div class="col-sm-3 col-md-2 text-right padding-r20" *ngIf="filterValueList.length > 0">
              <a href="Javascript:void(0);" class="clearAll" (click)="clearAllFilter()">Clear All</a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="row">
    <div class="col-md-12">
      <div class="fulfill-top-sec">
        <div class="row listing-action-items">
          <div class="col-xl-4 col-lg-4 col-md-4">
          </div>
          <div class="col-xl-8 col-lg-8 col-md-8 text-right">
            <mat-paginator #productPaginator [pageSize]="50" [pageSizeOptions]="[5, 10, 25, 50]"></mat-paginator>
          </div>
        </div>
      </div>
      <div class="tableContainer">
        <table mat-table #productTable [dataSource]="shipableProductDataSource" matSort matSortDirection="desc" class="matTables productTable resultTable">

          <ng-container matColumnDef="shipToAccount" sticky>
            <th mat-header-cell *matHeaderCellDef mat-sort-header class="shipToAcc text-center"> Account </th>
            <td mat-cell *matCellDef="let element" class="text-center shipToTxt">
              <p>{{element.shipToAccount}}</p>
            </td>
          </ng-container>

          <ng-container matColumnDef="accountName">
            <th mat-header-cell *matHeaderCellDef mat-sort-header class="accName text-center"> Account Name </th>
            <td mat-cell *matCellDef="let element" class="text-center">
              <p>{{element.accountName}}</p>
            </td>
          </ng-container>

          <ng-container matColumnDef="city">
            <th mat-header-cell *matHeaderCellDef mat-sort-header class="accCity text-center"> Account City </th>
            <td mat-cell *matCellDef="let element" class="text-center">
              <p>{{element.city}}</p>
            </td>
          </ng-container>

          <ng-container matColumnDef="state">
            <th mat-header-cell *matHeaderCellDef mat-sort-header class="accState text-center"> Account State </th>
            <td mat-cell *matCellDef="let element" class="text-center">
              <p>{{element.state}}</p>
            </td>
          </ng-container>

          <ng-container matColumnDef="itemNumber">
            <th mat-header-cell *matHeaderCellDef mat-sort-header class="itemNo text-center"> Item Number </th>
            <td mat-cell *matCellDef="let element" class="text-center">
              <p>{{element.itemNumber}}</p>
            </td>
          </ng-container>

          <ng-container matColumnDef="itemDescription">
            <th mat-header-cell *matHeaderCellDef mat-sort-header class="itemDesc text-center"> Item Description </th>
            <td mat-cell *matCellDef="let element" class="text-center">
              <p>{{element.itemDescription}}</p>
            </td>
          </ng-container>

          <ng-container matColumnDef="desiredDeliveryDate">
            <th mat-header-cell *matHeaderCellDef mat-sort-header class="deliveryDate text-center">Desired Delivery Date</th>
            <td mat-cell *matCellDef="let element" class="text-center">
              <p>{{element.desiredDeliveryDate | date:'MM-dd-yyyy'}}</p>
            </td>
          </ng-container>
          <ng-container matColumnDef="growerOrderUnits">
            <th mat-header-cell *matHeaderCellDef mat-sort-header class="growerOrderUnit text-center"> Grower Order Units </th>
            <td mat-cell *matCellDef="let element" class="text-center">
              <p>{{element.growerOrderUnits}}</p>
            </td>
          </ng-container>
          <ng-container matColumnDef="productLineDescription">
            <th mat-header-cell *matHeaderCellDef mat-sort-header class="prodLine text-center"> Product Line </th>
            <td mat-cell *matCellDef="let element" class="text-center">
              <p>{{element.productLineDescription}}</p>
            </td>
          </ng-container>
          <ng-container matColumnDef="marketingBrandDescription">
            <th mat-header-cell *matHeaderCellDef mat-sort-header class="marketingBrand text-center"> Marketing Brand </th>
            <td mat-cell *matCellDef="let element" class="text-center">
              <p>{{element.marketingBrandDescription}}</p>
            </td>
          </ng-container>
          <ng-container matColumnDef="brand">
            <th mat-header-cell *matHeaderCellDef mat-sort-header class="brand text-center"> Product Name </th>
            <td mat-cell *matCellDef="let element" class="text-center">
              <p>{{element.brand}}</p>
            </td>
          </ng-container>
          <ng-container matColumnDef="productCategoryDescription">
            <th mat-header-cell *matHeaderCellDef mat-sort-header class="technology text-center"> Technology </th>
            <td mat-cell *matCellDef="let element" class="text-center">
              <p>{{element.productCategoryDescription}}</p>
            </td>
          </ng-container>
          <ng-container matColumnDef="seedSizeDescription">
            <th mat-header-cell *matHeaderCellDef mat-sort-header class="seedSize text-center"> Seed Size </th>
            <td mat-cell *matCellDef="let element" class="text-center">
              <p>{{element.seedSizeDescription}}</p>
            </td>
          </ng-container>
          <ng-container matColumnDef="softCommitUnits">
            <th mat-header-cell *matHeaderCellDef mat-sort-header class="softCommit text-center"> Soft Commit </th>
            <td mat-cell *matCellDef="let element" class="text-center">
              <p>{{element.softCommitUnits}}</p>
            </td>
          </ng-container>
          <ng-container matColumnDef="hardCommitUnits">
            <th mat-header-cell *matHeaderCellDef mat-sort-header class="hardCommit text-center"> Hard Commit </th>
            <td mat-cell *matCellDef="let element" class="text-center">
              <p>{{element.hardCommitUnits}}</p>
            </td>
          </ng-container>
          <ng-container matColumnDef="totalDealerOrderUnits">
            <th mat-header-cell *matHeaderCellDef mat-sort-header class="totDlrOrder text-center"> Total Dealer Order </th>
            <td mat-cell *matCellDef="let element" class="text-center">
              <p>{{element.totalDealerOrderUnits}}</p>
            </td>
          </ng-container>
          <ng-container matColumnDef="shippableQuantity">
            <th mat-header-cell *matHeaderCellDef mat-sort-header class="shippable text-center"> Shippable </th>
            <td mat-cell *matCellDef="let element" class="text-center">
              <p>{{element.shippableQuantity}}</p>
            </td>
          </ng-container>
          <tr mat-header-row *matHeaderRowDef="displayedColumns;sticky:true;"></tr>
          <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
        </table>
        <div *ngIf="shipableProductDataSource == undefined || shipableProductDataSource?.data.length == 0" class="noDataMsg growerAudit">
          <p>No Record Found.</p>
        </div>
      </div>
    </div>
  </div>
</div>
